export default {
    index:{
        iconav1:'High-End',
        iconav2:'stabil',
        iconav3:'neues Produkt',
        iconav4:'Beutel mit Geschenken',
        iconav5:'Sicherheit',
        iconav6:'Öffentliche Informationen',
        iconav7:'vernünftig',
        iconav8:'Über uns',

        hottitle:'Hot List',
        weekrhot:'Heiß diese Woche',
        buybtn : 'Panik kaufen',
        rate : 'Verdienst im letzten Jahr',

        yjtitle : 'Stabile Tastenoptimierung',
        dqtitle : 'Kurzfristiges Finanzmanagement',
        sytitle : 'Umsatzführer',

        sstitle : 'Plattformsicherheitsbetrieb',
        day : 'Himmel',
        yy : 'Yuan',
        wp : 'Menschen',
        safe_desc1 : 'Stabiler Betrieb',
        safe_desc2 : 'Transaktionshöhe',
        safe_desc3 : 'Anzahl der Servicenutzer',

    },
    error:{
        error_400 : 'Serverfehler',
        error_401 : 'Login-Zeitüberschreitung, bitte erneut einloggen!',
        error_1001 : 'Ungültiges Argument',
        error_1002 : 'Parameter ist leer',
        error_1003 : 'Parametertypfehler',
        error_1004 : 'Fehlende Parameter',
        error_2001 : 'Benutzer ist nicht angemeldet',
        error_2002 : 'Das Konto existiert nicht oder das Passwort ist falsch',
        error_2003 : 'Account wurde deaktiviert',
        error_2004 : 'Benutzer existiert nicht',
        error_2005 : 'Benutzer existiert bereits',
        error_3001 : 'Erstellung fehlgeschlagen',
        error_4001 : 'Das System ist beschäftigt, bitte versuchen Sie es später noch einmal',
        error_5001 : 'Daten nicht gefunden',
        error_5002 : 'Die Daten sind falsch',
        error_5003 : 'Daten sind bereits vorhanden',
        error_6004 : 'Ungültige Schnittstellenadresse',
        error_6005 : 'Zeitüberschreitung bei Schnittstellenanforderung',
    },
    login:{
        phone : 'Handy',
        Forget : 'Passwort vergessen',
        Reg   : 'Neue Benutzerregistrierung',
        login  : 'Anmelden',
        agreement  : 'Der Login-Vertreter hat die "Servicevereinbarung" und die "Datenschutzerklärung" gelesen und akzeptiert.',
        password : 'Passwort',
        phone_msg: 'Bitte geben Sie die Telefonnummer ein',
        pass_msg: 'Bitte geben Sie das Passwort ein'
    },
    reg:{
        reg : "registrieren",
        sendsms: "Senden Sie den Bestätigungscode",
        agreement: "Der registrierte Vertreter hat die „Servicevereinbarung“ und die „Datenschutzerklärung“ gelesen und akzeptiert.",
        repassword : 'Kennwort bestätigen',
        sms:"SMS-Bestätigungscode",
        sms_msg : "Bitte geben Sie den SMS-Bestätigungscode ein",
        vaildphone:"Bitte geben Sie die richtige Telefonnummer ein",
        reppass:"Die beiden Passwörter sind inkonsistent",
        vading : "Überprüfung...",
        sendok : "Erfolgreich gesendet",
        sendfail: "Senden fehlgeschlagen",
        sendphone:"Handynummer wurde registriert",
        sendvaid: "Bitte geben Sie den obigen Inhalt ein, bevor Sie den Bestätigungscode senden"


    },
    forget:{
        btnedit:"ändere das Passwort",
        pagetitle:"Passwort abrufen",
        submitok:"Erfolgreich geändert",
        submitfail: "nicht bearbeiten"
    },
    details:{
        pagetitle: 'Produktdetails',
        qryear : 'Siebentägige annualisierte Rate',
        qx:'Projektschluss',
        lilu:'Zinsrate',
        etitle: 'Grundinformation',
        proname: 'Vollständiger Name des Projekts',
        pronano: 'Projektnummer',
        prorisk: 'Projekttyp',
        protime: 'Gründungsdatum',
        proscale: 'Projektumfang',
        start_threshold: 'Startbetrag',
        term: 'Projektschluss',
        is_repeat: 'Kann reinvestieren',
        insurance: 'Projektversicherung',
        dettitle: 'Einzelheiten',
        buyMoney: 'Kaufpreis',
        buyMsg: 'Bitte geben Sie den Kaufbetrag ein',
        buy: 'Kaufe jetzt',
        buyok: 'Erfolgreicher Kauf',
        buyfail: 'Fehlgeschlagener Kauf',
    },
    prolist:{
        pagetitle: 'Stabiles Finanzmanagement',
        mintitle : 'Empfohlen Empfohlen',
        comment : 'Bewertungen',
        m1title : 'Kurzfristiges Finanzmanagement',
        m2title : 'Stabile Tastenoptimierung',
        m3title : 'Umsatzführer',
    },
    me:{
        amount: "Gleichgewicht",
        frozen: "Eingefrorene Menge",
        icotitle1: "Aufladen",
        icotitle2: "abheben",
        icotitle3: "Onlineservice",
        icotitle4: "Finanzielle",
        icotitle5: "Information",
        linktitle1: "Persönliche Informationen",
        linktitle2: "Meine Investition",
        linktitle3: "Empfehle einen Freund",
        linktitle4: "meine Information",
        linktitle5: "Lade App herunter",
        linktitle6: "Sprachumschaltung",
        linktitle7: "Agentenzentrum",
        logout : "austragen",
        jstitle : 'Verlassen',
        jscom  : 'Melden Sie sich wirklich ab？'
    },
    userinfo:{
        username:'Nutzername',
        name:'Name',
        rename: 'richtiger Name',
        moneyAddr : 'Empfangsadresse',
        moneyStr : 'Wallet-Adresse',
        tj   : 'einreichen',
        avatar : 'Benutzerbild',
        pagetitle : 'Persönliche Informationen',
        user_tips : 'Bitte geben sie einen Benutzernamen ein',
        mobile_tips : "Bitte füllen Sie das Telefon aus",
        name_tips : 'Bitte geben Sie Ihren richtigen Namen ein',
        money_tips : 'Bitte geben Sie die korrekte Zahlungsadresse ein',
        update_tips : 'Es wurden keine Daten geändert',
        format_tips : 'Bitte laden Sie ein Bild im jpg- oder gif- oder png-Format hoch',
        size_tips : 'Das Bild darf nicht größer als 3 M sein'
    },
    recharge:{
        chargetype: 'Aufladetyp',
        usdt: 'USDT',
        ylcharge: 'UnionPay',
        czmoney: 'Aufladebetrag',
        inmoney: 'Bitte Betrag eingeben',
        rinmoney: 'Bitte geben Sie den korrekten Betrag ein',
        tips_title: 'Vorsichtsmaßnahmen',
        charge_tips: 'Nach dem Absenden der Aufladung müssen Sie eine Weile warten, wir werden uns rechtzeitig darum kümmern! Sollte der Account nicht fristgerecht eingehen, bitte den Kundenservice kontaktieren!',
    },
    withdrawal : {
        pagetitle : 'abheben',
        txmoney : 'Auszahlungsbetrag',
        tx_info : 'Nach dem Absenden der Aufladung müssen Sie eine Weile warten, wir werden uns rechtzeitig darum kümmern! Wenn das Konto nicht rechtzeitig eingeht, wenden Sie sich bitte an den Kundenservice！',
        tx_ok : 'Erfolgreich abheben',

    },
    financial : {
        pagetitle : 'Finanzielle Details',
        tabtitle1 : 'alle',
        tabtitle2 : 'Aufladen',
        tabtitle3 : 'abheben',
        tabtitle4 : 'investieren',
        tabtitle5 : 'Hergeben',
        tabtitle6 : 'Einkommen',
        noMore : 'Nicht mehr',
        updatedata : '{Count} Daten aktualisiert'
    },
    my_investment : {
        pagetitle : 'Meine Investition'
    },
    share : {
        pagetitle : 'Freunde teilen',
        nanoid : 'Mein Empfehlungscode',
        myfriend : 'Mein empfohlener Freund',
        levelfriend : 'Mitglied der {value}-Ebene',
    },
    message :{
        pagetitle : 'meine Information',
        tabtitle1 : 'Alle Nachrichten',
        tabtitle2 : 'System Information',
        tabtitle3 : 'Plattformbenachrichtigung',
        loading : 'Wird geladen...'
    },
    app_down : {
        pagetitle : 'App-Download',
    },
    system :{
        back : 'Rückkehr',
        project : "Projekt",
        home : 'Titelseite',
        kefu : 'anschließen',
        me : 'Bergwerk',
        lang: 'Sprache wechseln'
    },
    recommend:{
        noContent : 'noch kein Inhalt',
        newProject : 'Neueste Produkte'
    }
}
